export enum OnboardingCloudEnum {
	Aws = 'AWS',
	Azure = 'AZURE',
}
